import debounce from "lodash.debounce";

class ExtendedSearch extends HTMLElement {
  input?: HTMLElement | null;
  relatedCollections?: HTMLElement | null;
  relatedPages?: HTMLElement | null;
  collections: any[] = [];
  pages: any[] = [];

  connectedCallback() {
    this.relatedCollections = this.querySelector("[data-relatedcollections]");
    this.relatedPages = this.querySelector("[data-relatedpages]");
    this.input = this.querySelector("[data-extendedinput]");
    this.query = this.query.bind(this);

    if (this.input?.value) {
      this.handleQuery(this.input?.value);
    }

    this.input?.addEventListener("keyup", this.handleQuery);
  }

  disconnectedCallback() {
    this.input?.removeEventListener("keyup", this.handleQuery);
  }

  handleQuery = debounce((e) => this.query(e.target.value), 500);

  async query(searchTerm?: string) {
    if (!this.relatedCollections && !this.relatedPages) return;

    if (!searchTerm) {
      if (this.relatedCollections) {
        this.relatedCollections.innerHTML = "";
      }
    }

    const response = await fetch(`/search/suggest.json?q=` + searchTerm);
    const json = await response.json();

    if (this.relatedCollections) {
      this.relatedCollections.classList.add("visually-hidden");
      this.relatedCollections.innerHTML = "";
    }

    this.collections = json?.resources?.results?.collections;
    this.pages = json?.resources?.results?.pages;

    if (this.relatedCollections && this.collections.length) {
      this.relatedCollections.classList.remove("visually-hidden");

      this.collections?.forEach((collection) => {
        let btnText: string | null = collection?.title
          .toLowerCase()
          .replace(searchTerm.toLowerCase(), `<strong>${searchTerm.toLowerCase()}</strong>`);
        this.relatedCollections.innerHTML += `<a href="${collection?.url}" class="extended-search-button button button--small">${btnText}</a>`;
      });
    }

    if (this.relatedPages && this.pages.length) {
      this.relatedPages.classList.remove("visually-hidden");
    }
  }
}

customElements.define("extended-search", ExtendedSearch);
